var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading1',{attrs:{"active":_vm.data_in.show,"is-full-page":_vm.data_in.fullPage,"loader":_vm.data_in.type,"color":_vm.data_in.color},on:{"update:active":function($event){return _vm.$set(_vm.data_in, "show", $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }